export const Nav = (props) => {
    return <nav>{props.children}</nav>
}